export default "/fonts/Muli-Black.ttf?65e46745a5a5486857ace6a896d598a4";